<script>/**
 * Topbar component
 */
import simplebar from "simplebar-vue";
import {thongBaoModel} from "@/models/thongBaoModel";
import {userModel} from "@/models/userModel";
import {mapState} from "vuex";

export default {
  data() {
    return {
      currentUserAuth: null,
      url: process.env.VUE_APP_API_URL + 'files/view/',
      model: thongBaoModel.baseJson(),
      modelUser: userModel.baseJson(),
      listNotify: [],
      showModal: false,
      showModalLogout: false,
      subNotify: {
        vanBanDi: 0,
        vanBanDen: 0,
        hopThu: 0,
        thongBao: 0
      }
    };
  },
  components: {simplebar},
  mounted() {
    this.getListNotify();
  },
  computed:{
    ...mapState('notifyStore', ['isReloadNotify']),
    files() {
      if (this.model && this.model.files && this.model.files.length > 0) {
        var arrayFiles = this.model.files[this.model.files.length - 1];
        return [arrayFiles];
      }
      return []
    }
  },
  watch: {
    isReloadNotify() {
      this.getSubNotify();
    },
  },
  created() {
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent.user;
    }
    this.getSubNotify();
  },
  methods: {
    handleXemTatCa() {
      if (this.$route.path != '/thong-bao-chung')
        this.$router.push('/thong-bao-chung')
    },
    handleThongTinCaNhan() {
      if (this.$route.path != '/thong-tin-ca-nhan') {
        this.$router.push("/thong-tin-ca-nhan");
      }
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      var userLocalStorage = localStorage.getItem("user-token");
      if (userLocalStorage) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("auth-user");
        localStorage.removeItem("TabData");
        this.$router.push("/dang-nhap");
        return;
      }
    },
    async handleNotifyDetail(id) {
      await this.$store
          .dispatch("notificationStore/getById", id)
          .then((res) => {
            this.model = res;
            this.showModal = true;
          });
    },
    async handleDetailUser(id) {
      await this.$store.dispatch("userStore/getById", id).then((res) => {
        this.modelUser = userModel.fromJson(res.data);
        this.showModal = true;
      });
    },
    async handleChangeStatus(id) {
      this.model.id = id;
      await this.$store.dispatch("notifyStore/changeStatus", this.model).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.getListNotify();
        }
      });
    },
    getListNotify() {
      this.$store.dispatch("notifyStore/getListNotify").then((res) => {
        this.listNotify = res.data || [];
      });
    },
    getSubNotify() {
      this.$store.dispatch("notifyStore/subNotify").then((res) => {
        this.subNotify = res.data || [];
      });
    },
  },
};
</script>
<template>
  <header id="page-topbar">
    <div class="navbar-header" style="background-color: #fff; box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box d-flex align-items-center justify-content-center" style="">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt height="22"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17"/>
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light d-flex align-items-center justify-content-center">
            <span class="logo-sm">
              <img src="@/assets/images/DTHU.png" class="logo-dthu-sm" alt="logo dthu"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/d-office.png" alt height="35"/>
            </span>
          </router-link>
        </div>

        <button
            type="button"
            class="btn btn-sm px-3 font-size-24 header-item "
            id="vertical-menu-btn"
            @click="toggleMenu()"
        >
          <i class="mdi mdi-menu text-primary"></i>
        </button>
        <!--        <div class="d-none d-sm-block">-->
        <!--          <h5 class="pt-4 d-inline-block text-white fs-5 fw-medium">Trường Đại học Đồng Tháp</h5>-->
        <!--        </div>-->
        <div class="align-items-center d-none d-sm-flex cs-menu-top">
          <router-link
              tag="a"
              class-active="active"
              class="p-2 item-link"
              to="/xu-ly-van-ban-den"
              exact
          >
            <p class="cs-item-topbar"> Văn bản đến</p>
            <span :class="`badge rounded-pill bg-danger float-end`" class="cs-notify">{{subNotify.vanBanDen}}</span
            >
          </router-link>
          <router-link
              tag="a"
              class-active="active"
              class="p-2 item-link"
              to="/xu-ly-van-ban-di"
              exact
          >
            <p class="cs-item-topbar">Ban hành văn bản</p>
            <span :class=" `badge rounded-pill bg-danger float-end`" class="cs-notify">{{subNotify.vanBanDi}}</span>
          </router-link>
          <router-link
              tag="a"
              class-active="active"
              class="p-2 item-link"
              to="/thu-den"
              exact
          >
            <p class="cs-item-topbar">Hộp thư</p>
            <span :class=" `badge rounded-pill bg-danger float-end`" class="cs-notify">{{subNotify.hopThu}}</span>
          </router-link>
          <router-link
              tag="a"
              class-active="active"
              class="p-2 item-link"
              to="/merge-thongbao"
              exact
          >
            <p class="cs-item-topbar">Thông báo</p>
            <span :class="`badge rounded-pill bg-danger float-end`" class="cs-notify">{{subNotify.thongBao}}</span>
          </router-link>
        </div>
      </div>

      <div class="d-flex">

        <!--        <b-dropdown-->
        <!--          variant="white"-->
        <!--          class="d-inline-block"-->
        <!--          toggle-class="header-item noti-icon"-->
        <!--          menu-class="dropdown-menu-lg dropdown-menu-end"-->
        <!--        >-->
        <!--          <template v-slot:button-content>-->
        <!--            <i class="mdi mdi-magnify"></i>-->
        <!--          </template>-->
        <!--          <form class="p-3">-->
        <!--            <div class="form-group m-0">-->
        <!--              <div class="input-group">-->
        <!--                <input-->
        <!--                  type="text"-->
        <!--                  class="form-control"-->
        <!--                  placeholder="Search ..."-->
        <!--                  aria-label="Recipient's username"-->
        <!--                />-->
        <!--                <div class="input-group-append">-->
        <!--                  <button class="btn btn-primary" type="submit">-->
        <!--                    <i class="mdi mdi-magnify"></i>-->
        <!--                  </button>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </form>-->
        <!--        </b-dropdown>-->
        <!-- App Search-->

        <!--        <b-dropdown-->
        <!--          class="d-none d-md-block ms-2"-->
        <!--          toggle-class="header-item"-->
        <!--          menu-class="dropdown-menu-end"-->
        <!--          right-->
        <!--          variant="white"-->
        <!--        >-->
        <!--          <template v-slot:button-content>-->
        <!--            <img-->
        <!--              class="me-2"-->
        <!--              src="@/assets/images/flags/us_flag.jpg"-->
        <!--              alt="Header Language"-->
        <!--              height="16"-->
        <!--            />-->
        <!--            English-->
        <!--            <span class="mdi mdi-chevron-down"></span>-->
        <!--          </template>-->
        <!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
        <!--            <img-->
        <!--              src="@/assets/images/flags/germany_flag.jpg"-->
        <!--              alt="user-image"-->
        <!--              class="me-1"-->
        <!--              height="12"-->
        <!--            />-->
        <!--            <span class="align-middle">German</span>-->
        <!--          </a>-->

        <!--          &lt;!&ndash; item&ndash;&gt;-->
        <!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
        <!--            <img-->
        <!--              src="@/assets/images/flags/italy_flag.jpg"-->
        <!--              alt="user-image"-->
        <!--              class="me-1"-->
        <!--              height="12"-->
        <!--            />-->
        <!--            <span class="align-middle">Italian</span>-->
        <!--          </a>-->

        <!--          &lt;!&ndash; item&ndash;&gt;-->
        <!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
        <!--            <img-->
        <!--              src="@/assets/images/flags/french_flag.jpg"-->
        <!--              alt="user-image"-->
        <!--              class="me-1"-->
        <!--              height="12"-->
        <!--            />-->
        <!--            <span class="align-middle">French</span>-->
        <!--          </a>-->

        <!--          &lt;!&ndash; item&ndash;&gt;-->
        <!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
        <!--            <img-->
        <!--              src="@/assets/images/flags/spain_flag.jpg"-->
        <!--              alt="user-image"-->
        <!--              class="me-1"-->
        <!--              height="12"-->
        <!--            />-->
        <!--            <span class="align-middle">Spanish</span>-->
        <!--          </a>-->

        <!--          &lt;!&ndash; item&ndash;&gt;-->
        <!--          <a href="javascript:void(0);" class="dropdown-item notify-item">-->
        <!--            <img-->
        <!--              src="@/assets/images/flags/russia_flag.jpg"-->
        <!--              alt="user-image"-->
        <!--              class="me-1"-->
        <!--              height="12"-->
        <!--            />-->
        <!--            <span class="align-middle">Russian</span>-->
        <!--          </a>-->
        <!--        </b-dropdown>-->

        <div class="dropdown d-none d-lg-inline-block">
          <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen"
          >
            <i class="mdi mdi-fullscreen text-primary"></i>
          </button>
        </div>
        <!-- ./start Notify -->
        <b-dropdown
            class="d-inline-block"
            toggle-class="header-item noti-icon"
            menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
            right
            variant="white"
        >
          <template v-slot:button-content>
            <i class="mdi mdi-bell-outline text-primary"></i>
            <span v-if="listNotify.number > 0" class="badge bg-danger rounded-pill">{{ listNotify.number }}</span>
          </template>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <p class="m-0 font-size-16 fw-bold text-black">Thông báo</p>
              </div>
<!--              <div class="col-auto">-->
<!--                <a href="/thong-bao" class="small"> Tất cả </a>-->
<!--              </div>-->
            </div>
          </div>
          <simplebar style="max-height: 300px">
            <a
                href="javascript: void(0);"
                class="text-reset notification-item"
                v-for="items in listNotify.listNotify"
                :key="items.id"
                @click="handleNotifyDetail(items.id),handleDetailUser(items.senderId),handleChangeStatus(items.id)"
            >
              <div>
                <div class="d-flex align-items-center">
                  <div class="avatar-xs me-3">
                    <span
                        class="bg-primary rounded-circle font-size-16 text-light p-2 mt-2"
                    >
                      <i class="fas fa-scroll"></i>
                    </span>
                  </div>
                  <div class="flex-grow-1 notify-content-box px-2">
                    <h6 class="mt-0 mb-1  title-capso" :inner-html.prop="items.title | truncate(60)">

                    </h6>

                    <div class="font-size-12 text-muted ntf-content">
                      <p class="mb-1" :inner-html.prop="items.content | truncate(60)">
                      </p>
                    </div>
                  </div>
                  <div class="icon-box p-2">
                    <i v-if="items.read == true" class="bx bxs-circle text-light"></i>
                    <i v-else-if="items.read == false" class="bx bxs-circle text-primary"></i>
                  </div>
                </div>
              </div>
            </a>

          </simplebar>
          <div class="p-2 border-top">
            <div class="d-grid">
              <a
                  class="btn btn-sm btn-link font-size-14 text-center"
                  href="javascript:void(0)"
                  @click="handleXemTatCa"
              >
                Xem tất cả
              </a>
            </div>
          </div>
        </b-dropdown>
        <!-- ./ end Notify -->
        <b-dropdown
            class="d-inline-block"
            right
            toggle-class="header-item"
            variant="white"
            menu-class="dropdown-menu-end dropdown-menu-lg p-0"

        >
          <!--          <template v-slot:button-content>-->
          <!--            <img-->
          <!--              class="rounded-circle header-profile-user"-->
          <!--              src="@/assets/images/users/user-4.jpg"-->
          <!--              alt="Header Avatar"-->
          <!--            />-->

          <!--          </template>-->
          <template v-slot:button-content>
            <div style="display:flex; justify-content:center; align-content:center">
                         <span>
              <span v-if="currentUserAuth.avatar">
                <b-img
                    :src=" url + `${currentUserAuth.avatar.fileId}`"
                    alt="Avatar"
                    class="rounded-circle header-profile-user"
                >
                </b-img>
              </span>
              <span v-else>
                <img
                    class="rounded-circle header-profile-user"
                    src="@/assets/images/users/user-4.jpg"
                    alt="Avatar"
                />
              </span>
            </span>&nbsp;
              <span class="d-none d-xl-inline-block ms-1">
              <div v-if="currentUserAuth" style="font-size: 10px;">
                <div style="font-size: 12px" class="text-primary">
                  {{ currentUserAuth.fullName }}
                  <i class="mdi mdi-chevron-down d-none d-xl-inline "></i>
                </div>
                <div class="text-start text-dark">
                  @{{ currentUserAuth.userName }}
                </div>
              </div>
              <div v-else>
               AnhDev99
              </div>
              </span
              >
            </div>

          </template>

          <!--  dropdown profile -->
          <div class="overflow-hidden cs-shadow-profile">
            <div class="bg-soft bg-soft-dark custom-image">
              <div class="row">
                <div class="col-12" style="height: 100px">
                  <div class="text-primary p-2 text-center">
<!--                    <h5 class="text-dark text-uppercase py-3">Người dùng</h5>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-0 mb-3">
              <div class="row">
                <div class="col-sm-12 align-self-center">
                  <div class="avatar-md profile-user-wid mb-2 w-100 d-flex flex-column align-items-center">
                    <div style="margin-top: -35px;">
                      <div v-if="currentUserAuth.avatar">
                        <b-img
                            :src=" url + `${currentUserAuth.avatar.fileId}`"
                            alt
                            class="img-thumbnail rounded-circle"
                            style="height: 72px ; width: 72px"
                        >
                        </b-img>
                      </div>
                      <div v-else>
                        <img
                            class="img-thumbnail rounded-circle"
                            style="height: 72px ; width: 72px"
                            alt
                            src="@/assets/images/4.png"
                        />
                      </div>
                    </div>
                    <div v-if="currentUserAuth" class="text-center">
                      <h5 class="font-size-15 text-dark fw-bold">{{ currentUserAuth.fullName }}</h5>
                      <p class="mb-0 text-dark">@{{ currentUserAuth.userName }}</p>
                    </div>
                  </div>
                </div>

                <!--              <div class="col-sm-6">-->
                <!--                <div class="pt-4">-->
                <!--                  <div class="row">-->
                <!--                    <div class="col-6">-->
                <!--                      <h5 class="font-size-15">125</h5>-->
                <!--                      <p class="text-muted mb-0">Projects</p>-->
                <!--                    </div>-->
                <!--                    <div class="col-6">-->
                <!--                      <h5 class="font-size-15">$1245</h5>-->
                <!--                      <p class="text-muted mb-0">Revenue</p>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--              </div>-->
              </div>
            </div>
            <b-dropdown-item>
              <a v-on:click="handleThongTinCaNhan">
                <i
                    class="mdi mdi-account-circle font-size-17 align-middle me-1"
                ></i>
                Thông tin cá nhân
              </a>
            </b-dropdown-item>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger mb-2" v-on:click="showModalLogout = true" style="cursor: pointer;">
              <i
                  class="mdi mdi-logout font-size-17 align-middle me-1"
              ></i>
              Đăng xuất
            </a>
          </div>
          <!-- end dropdown profile -->


        </b-dropdown>
      </div>
    </div>
    <!--    <b-modal-->
    <!--        v-model="showModal"-->
    <!--        id="modal-lg"-->
    <!--        size="lg"-->
    <!--        body-class="p-0"-->
    <!--        hide-footer-->
    <!--    >-->
    <!--      <template #modal-header="{ }">-->
    <!--        &lt;!&ndash; Emulate built in modal header close button action &ndash;&gt;-->
    <!--        <h5> Thông báo</h5>-->
    <!--        <div class="text-end">-->
    <!--          <b-button variant="light" size="sm" style="width: 80px" @click="showModal = false">-->
    <!--            Đóng-->
    <!--          </b-button>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--      <div class="card-body p-3">-->
    <!--        <h4 class="mt-0 font-size-16 title-capso" style="font-weight: bold">{{model.title}}</h4>-->
    <!--        <div class="d-flex mb-2  mt-2">-->
    <!--          <span>-->
    <!--              <span v-if="modelUser.avatar">-->
    <!--                <img-->
    <!--                    :src="url + `${modelUser.avatar.fileId}`"-->
    <!--                    alt="Avatar"-->
    <!--                    class="d-flex me-3 rounded-circle avatar-sm"-->
    <!--                />-->

    <!--              </span>-->
    <!--              <span v-else>-->
    <!--                <img-->
    <!--                    class="d-flex me-3 rounded-circle avatar-sm"-->
    <!--                    src="@/assets/images/4.png"-->
    <!--                    alt="Avatar"-->
    <!--                />-->
    <!--              </span></span>&nbsp;-->
    <!--          <div class="flex-grow-1">-->
    <!--            <h5 class="font-size-14 mt-1">{{model.sender}}</h5>-->
    <!--            <small class="text-muted">tới {{model.recipient}}</small>-->

    <!--          </div>-->
    <!--          <div class="flex-grow-2">-->
    <!--            <small class="text-muted" style="float: right"><i>Ngày gửi: {{ model.createdAtShow }} {{model.createdAtTimeShow}}</i></small>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <p v-if="model.content" :inner-html.prop="model.content">-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </b-modal>-->
    <b-modal
        v-model="showModal"
        id="modal-lg"
        size="lg"
        body-class="p-0"
        hide-footer
        no-close-on-backdrop
    >
      <template #modal-header="{ }">
        <!-- Emulate built in modal header close button action -->
        <h5 class="fw-bold fs-5 text-dark"> Thông báo</h5>
        <div class="text-end">
          <b-button v-if="model.loaiCongVan && model.congVanId" variant="info" size="sm"
                    style="width: 120px; margin-right: 10px" @click="handleLuuCV(model.loaiCongVan, model.congVanId)">
            Lưu CV nội bộ
          </b-button>
          <b-button variant="light" size="sm" style="width: 80px" @click="showModal = false">
            Đóng
          </b-button>
        </div>
      </template>
      <div class="px-5 py-3">
        <div class="row mt-3 mb-3">
          <div class="col-12 p-0">
            <h4 v-html="model.title" class="mt-0 font-size-16 mb-2" style="font-weight: bold;color: #00568C"></h4>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-8 col-12 d-flex align-items-center sender-box p-0">
            <div class="">
                <span v-if="modelUser.avatar">
                  <img
                      :src="url + `${modelUser.avatar.fileId}`"
                      alt="Avatar"
                      class="d-flex me-3 rounded-circle avatar-sm"
                  />

                </span>
              <span v-else>
                  <img
                      class="d-flex me-2 rounded-circle avatar-sm"
                      src="@/assets/images/4.png"
                      alt="Avatar"
                  />
              </span>
            </div>
            <div class="">
              <div class="flex-grow-1 d-flex justify-content-start align-items-center">
                <p class="font-size-14 text-dark mb-0">Người gửi: </p>
                <p class="m-0 ms-2 fw-bold text-dark">{{ model.sender }}</p>
              </div>
              <div class="flex-grow-1 d-flex justify-content-start align-items-center">
                <p class="font-size-14 text-dark mb-0">Đến tôi: </p>
                <p class="m-0 ms-2 fw-bold badge text-success px-1 font-size-13"
                   style="background-color: rgba(2,164,153,0.2); border-radius: 3px;"
                >{{ model.recipient }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="flex-grow-2 p-1">
              <small class="text-muted font-size-14" style="float: right"><i>Ngày gửi: {{ model.createdAtShow }}
                {{ model.createdAtTimeShow }}</i></small>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <hr>
        </div>
        <div class="row">
          <div class="col-12 ">
            <p
                style="color: #00568C; text-align: justify;"
                v-if="model.content"
                :inner-html.prop="model.content"
                class="mb-0 ps-5"
            >
            </p>
          </div>
        </div>

        <div class="row mb-1 mt-2" v-if="files && files.length > 0">
          <div class="col-md-12"
               style="display: flex; flex-direction: column; padding: 0px"
          >
            <h5 class="font-size-14 text-dark">Văn bản trình ký </h5>
            <div

            >
              <div
                  v-for="(value, index) in files" :key="index"
                  style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px"
              >
                <a
                    :href="`${apiUrl}files/view/${value.fileId}`"
                    class=" fw-medium"
                ><i
                    class="fas fa-cloud-download-alt"
                ></i>
                  [Tải về]</a
                >

                <a
                    target="_blank"
                    class="fw-medium text-danger"
                    @click="handleShowFile(value.fileId)"
                    style="cursor: pointer"
                >
                  [Xem]</a>
                <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>

              </div>
            </div>
          </div>
        </div>

        <!--        Phụ lục đính kèm-->
        <div class="row mb-1 mt-1" v-if="model.filesPhuLuc && model.filesPhuLuc.length > 0">
          <div class="col-md-12"
               style="display: flex; flex-direction: column; padding: 0px"
          >
            <h5 class="font-size-14 text-dark text-bold">Hồ sơ kèm theo </h5>
            <div

            >
              <div
                  v-for="(value, index) in model.filesPhuLuc" :key="index"
                  style="background-color: rgba(47,147,224,0.1); border-radius: 3px; padding: 5px; margin-bottom: 5px"
              >
                <a
                    :href="`${apiUrl}files/view/${value.fileId}`"
                    class=" fw-medium"
                ><i
                    class="fas fa-cloud-download-alt"
                ></i>
                  [Tải về]</a
                >

                <a
                    target="_blank"
                    class="fw-medium text-danger"
                    @click="handleShowFile(value.fileId)"
                    style="cursor: pointer"
                >
                  [Xem]</a>
                <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="showModalLogout"
        id="modal-lg"
        size="md"
        centered
        body-class="p-0"
        hide-footer
        hide-header
        hide-header-close
        no-close-on-backdrop
    >
      <div class="card my-4 pt-3 shadow-none">
        <div class="card-body p-4">
          <div class="text-center">
            <div class="avatar-md mx-auto mb-4">
              <div
                  class="avatar-title bg-light rounded-circle text-danger h1"
              >
                <i class="mdi mdi-power"></i>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-xl-10">
                <h4 class="text-dark">Đăng xuất !</h4>
                <p class="text-muted font-size-14 mb-0">
                  Bạn có chắc chắn muốn đăng xuất không.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ./ footer -->
      <div class="modal-footer">
        <b-button variant="light" class="mt-2" size="md" block @click="showModalLogout = false">Đóng</b-button>
        <b-button class="mt-2" size="md" variant="danger" block @click="logoutUser">Đăng xuất</b-button>
      </div>
    </b-modal>
  </header>
</template>
<style>
.title-capso {
  font-weight: bold;
  color: #00568C;
  margin-right: 10px;

}
</style>

<style>
.logo-dthu-sm {
  width: 25px !important;
}
.custom-image{
  background-image: url("../assets/images/bg_login.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media only screen and (max-width: 768px) {
  .logo-dthu-sm {
    width: 40px !important;
    height: 100% !important;
  }

  .navbar-brand-box {
    background-color: transparent !important;
  }
}

.navbar-brand-box {
  background-color: transparent;
}

.title-thongbao {
  color: #00568C;
  margin-right: 10px;

}

.icon-notify {
  top: 20%;
  animation: ring 2s infinite;
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}

/*Thông báo*/

.info-box {
  background-color: #f5f5f5;
  padding: 5px;
  border-radius: 5px;
  border: 0.5px solid #f1f1f1;
  margin-bottom: 5px;
}

.cs-menu-top .item-link {
  color: #045f90 !important;
  font-weight: 500;
}

.cs-menu-top .router-link-active {
  color: #00568c !important;
  position: relative;
}

.cs-menu-top .router-link-active::before {
  content: "";
  display: block;
  height: 3px;
  width: 100%;
  background-color: #00568c;
  border-radius: 50px;
  position: absolute;
  left: 0;
  bottom: -12px;
}

/* page  topbar*/
#page-topbar .cs-menu-top .item-link{
  position: relative;
  margin-right: 10px;
  padding: 12px 20px !important
}

#page-topbar .cs-menu-top .item-link > p{
  color: #5b626b;
}

#page-topbar .cs-menu-top .item-link.router-link-active,
#page-topbar .cs-menu-top .item-link:hover{
  background-color: #f3f3f5;
  border-radius: 5px;
}
#page-topbar .cs-menu-top .item-link.router-link-active > p,
#page-topbar .cs-menu-top .item-link:hover > p{
  color: #055E8F !important;
}

#page-topbar .cs-menu-top .cs-notify{
  position: absolute;
  top: 4px;
  right: 4px;
}

#page-topbar .cs-item-topbar{
  margin-bottom: 0px;
}

@media only screen and (max-width: 756px){
  #page-topbar .cs-menu-top .item-link{
    padding: 12px 10px !important
  }
}
@media only screen and (max-width: 676px){
  #page-topbar .cs-menu-top .item-link{
    margin-right: 0px;
  }
}
@media only screen and (max-width: 633px){
  #page-topbar .cs-menu-top .item-link{
    display: none;
  }
}


.cs-shadow-profile {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}
</style>
